<mat-form-field
        [ngClass]="wrapperClasses"
        [appearance]="input.appearance"
        [floatLabel]="input.floatLabel" class="full-width">
    <mat-label>{{input.label}}</mat-label>
    <mat-chip-list #chipList [disabled]="input.control.disabled">
        <mat-chip *ngFor="let chip of chips" [value]="chip" (removed)="remove(chip)">
            <span>{{chip}}</span>
            <button [hidden]="input.control.disabled" type="button" matChipRemove>
                <mat-icon [matTooltip]="'Remove ' + chip">cancel</mat-icon>
            </button>
        </mat-chip>
        <input
            #searchInput
            [formControl]="inputControl"
            [placeholder]="input.placeholder"
            [matChipInputFor]="chipList"
            [matChipInputAddOnBlur]="true"
            (blur)="blurEvent($event)"
            (focus)="focusEvent($event)"
            (matChipInputTokenEnd)="add($event)"
        >
    </mat-chip-list>
    <mat-error>{{errorMessage}}</mat-error>
    <mat-hint [ngClass]="hint?.class">{{hint?.message}}</mat-hint>
</mat-form-field>
